<template>
  <div class="error-page">
    <div class="img-con">
      <img src="../../../assets/images/mine/errorpage.png" alt="" />
    </div>
    <div>您无权访问,请联系管理员</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.error-page {
  width: 100%;
  height: 100vh;
  .img-con {
    width: 3.74rem;
    height: 3.14rem;
    margin: 2rem auto 0;
    img{
        width: 100%;
        height: 100%;
    }
  }
  > div:last-child {
    margin-top: 0.2rem;
    text-align: center;
    color: #1883fe;
    font-size: 0.3rem;
  }
}
</style>